import { envToReasonablySizedString } from '../utils';

export const GOOGLE_MAPS_API_KEY = envToReasonablySizedString(process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY);
